import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const gbApi = axios.create({ baseURL: `${BACKEND_URL}/api/gb`, timeout: 30000 });

gbApi.interceptors.request.use((config) => {
  const t = localStorage.getItem('customer_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const gbFmt = (n) => Number(n || 0).toLocaleString('pt-BR');

export const MAP_LABEL = {
  pumpkin: 'Abóboras',
  graveyard: 'Cemitério',
  castle: 'Castelo',
};

export const MAP_THUMB = {
  pumpkin: '/gb/map_pumpkin.jpg',
  graveyard: '/gb/map_graveyard.jpg',
  castle: '/gb/map_castle.jpg',
};

export const gbError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d && typeof d === 'object') return Object.values(d)[0] || 'Falha na operação.';
  return 'Falha na operação. Tente novamente.';
};

export const FEATURE_LABEL = {
  terraces: 'Solo em terraços',
  floors: 'Dois andares',
  archipelago: 'Arquipélago',
  islands: 'Ilhas flutuantes',
  islands_hard: 'Ilhas mínimas',
};

// ícone próprio de cada fase (1–24), no tema da região
export const STAGE_ICON = (node) => `/gb/world/s${Math.min(24, Math.max(1, Number(node) || 1))}.png`;
